const content = {
    mainLink: "https://www.youtube.com/watch?v=B7oAaK80BhY",
    mainImage: "https://i.imgur.com/wAkclAY.png",
    welcomeMessage: "Ghostwriters out now"
};

export default content;
